var _path, _path2, _g, _path3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 277,
    viewBox: "0 0 1440 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V277H0V0Z",
    fill: "url(#paint0_linear_795_28097)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_795_28097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1014,
    y: 0,
    width: 426,
    height: 277
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1014 0H1440V277H1014V0Z",
    fill: "url(#paint1_linear_795_28097)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_795_28097)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1358.8 210.173V133.286L1309.37 170.353L1318.98 269.206L875.516 703.062L778.036 600.09L1237.98 141.52L1211.89 105.828C1241.64 78.8266 1319.26 10.2709 1391.75 -47.9427C1464.25 -106.156 1535.46 60.5214 1562 151.137L1531.8 105.828L1391.75 243.124L1358.8 210.173Z",
    fill: "url(#paint2_linear_795_28097)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_795_28097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 426,
    height: 277
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426 0H-1.75238e-05V277H426V0Z",
    fill: "url(#paint3_linear_795_28097)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_795_28097)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1958 210.173V133.286L130.628 170.353L121.017 269.206L564.484 703.062L661.964 600.09L202.022 141.52L228.108 105.828C198.36 78.8266 120.742 10.2709 48.2466 -47.9427C-24.2485 -106.156 -95.4574 60.5214 -122 151.137L-91.7999 105.828L48.2466 243.124L81.1958 210.173Z",
    fill: "url(#paint4_linear_795_28097)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_795_28097",
    x1: 283.49,
    y1: 125.612,
    x2: 563.347,
    y2: 858.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_795_28097",
    x1: 1123.4,
    y1: 125.612,
    x2: 1543.18,
    y2: 549.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_795_28097",
    x1: 1062.02,
    y1: 42,
    x2: 1327.03,
    y2: 667.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4147",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_795_28097",
    x1: 316.599,
    y1: 125.612,
    x2: -103.182,
    y2: 549.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2E33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_795_28097",
    x1: 377.977,
    y1: 42,
    x2: 112.969,
    y2: 667.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4147",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageBackground);
export default __webpack_public_path__ + "static/media/home-page-background.9f349d070cd232f33725997942275175.svg";
export { ForwardRef as ReactComponent };